import React from "react"

// import Auth from "auth";
// import { API } from "API"
import { APIPost, APIGet } from "services/APIRequest"
import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Configs from "services/ConfigHost"

import Lg from "language"

import Auth from "auth"
import { thaiBath } from "helpers/ConvertFormat"
import { ISOToDateYMDAndFullTime, ISOToDateDMYAndFullTime } from "helpers/ConvertDate"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsThemeSMSUpdate } from "store/actions"

import * as Alert from "alertService"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import AddCircleIcon from "@material-ui/icons/AddCircle"
import EditIcon from "@material-ui/icons/Edit"
import FilterListIcon from "@material-ui/icons/FilterList"
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TimerOffIcon from '@material-ui/icons/TimerOff';

// core components 
import ReactTable from "react-table"
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import CustomInput from "components/CustomInput/CustomInput"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import FileConfigUploadSingle from "components/CustomUpload/FileConfigUploadSingle"
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Datetime from "react-datetime";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "30px"
  },
  mb4: {
    marginBottom: "20px"
  }
}
class ProjectCreateAndEditManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      _id: null,

      themeName: "",
      txtSMSMessage: "",

      startDatetime: null,
      startDatetimeStatusReload: false,
      endDatetime: null,
      endDatetimeStatusReload: false,

      currentData: null
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.currentData != nextState.currentData) {
      var _currentData = nextProps.currentData
      console.log("--->> ", _currentData)
      if (_currentData == null) {
        this.setState({
          currentData: null,
          _id: null,
          themeName: "",
          txtSMSMessage: "",
          startDatetime: null,
          endDatetime: null,
          startDatetimeStatusReload: true,
          endDatetimeStatusReload: true,
        }, () => {
          this.setState({
            startDatetimeStatusReload: false,
            endDatetimeStatusReload: false,
          })
        })
      } else {
        this.setState({
          currentData: _currentData,
          _id: _currentData._id,
          themeName: _currentData.theme_name,
          txtSMSMessage: _currentData.txt_sms_message,
          startDatetime: _currentData.start_active_sms_date,
          endDatetime: _currentData.end_active_sms_date,
          startDatetimeStatusReload: true,
          endDatetimeStatusReload: true,
        }, () => {
          this.setState({
            startDatetimeStatusReload: false,
            endDatetimeStatusReload: false,
          })
        })
      }
    }
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleDateTimeRemove = (name) => {
    if (name == "startDatetime") {
      this.setState({
        startDatetime: null,
        startDatetimeStatusReload: true
      }, () => {
        this.setState({ startDatetimeStatusReload: false })
      })
    } else if (name == "endDatetime") {
      this.setState({
        endDatetime: null,
        endDatetimeStatusReload: true
      }, () => {
        this.setState({ endDatetimeStatusReload: false })
      })
    }
  }
  handleState = (key, val) => {
    this.setState({
      [key]: val
    })
  }
  handleSave = () => {
    if (this.state.themeName === "") {
      WarningCallback("ต้องการข้อมูล : ชื่อข้อมูล")
    } else if (this.state.txtSMSMessage === "") {
      WarningCallback("ต้องการข้อมูล : ข้อความ SMS")
    } else {
      if (!this.state._id) {
        Alert.Loading(true)
        const dataToSend = {
          themeName: this.state.themeName,
          txtSMSMessage: this.state.txtSMSMessage,
          startDatetime: this.state.startDatetime,
          endDatetime: this.state.endDatetime,
        }
        APIPost(UrlServer.URL_POST_THEME_SMS_CREATE, dataToSend, (datas) => {
          SuccessCallback(this.state.themeName, null, () => {
            this.setState({
              currentData: null,
              _id: null,
              themeName: "",
              txtSMSMessage: "",
              startDatetime: null,
              endDatetime: null,
              startDatetimeStatusReload: true,
              endDatetimeStatusReload: true,
            }, () => {
              this.setState({
                startDatetimeStatusReload: false,
                endDatetimeStatusReload: false,
              }, () => {
                this.props.listsThemeSMSUpdate(true)
                setTimeout(() => {
                  this.props.callbacksetTabIndex(0)
                }, 700);
              })
            })
          })
        })
      } else {
        Alert.Loading(true)
        const dataToSend = {
          _id: this.state._id,
          themeName: this.state.themeName,
          txtSMSMessage: this.state.txtSMSMessage,
          startDatetime: this.state.startDatetime,
          endDatetime: this.state.endDatetime,
        }
        APIPost(UrlServer.URL_POST_THEME_SMS_UPDATE, dataToSend, (datas) => {
          SuccessCallback(this.state.themeName, null, () => {
            this.setState({
              currentData: null,
              _id: null,
              themeName: "",
              txtSMSMessage: "",
              startDatetime: null,
              endDatetime: null,
              startDatetimeStatusReload: true,
              endDatetimeStatusReload: true,
            }, () => {
              this.setState({
                startDatetimeStatusReload: false,
                endDatetimeStatusReload: false,
              }, () => {
                this.props.listsThemeSMSUpdate(true)
                setTimeout(() => {
                  this.props.callbacksetTabIndex(0)
                }, 500);
              })
            })
          })
        })
      }
    }
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer key="gc-1">
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <CloudUploadIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {this.state._id ? "แก้ไข" : "สร้าง"} Theme SMS ที่ต้องการเตรียมไว้
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer key="gc-2">
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ชื่อธีม
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        error={this.state.themeName == ""}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          disabled: this.state.dataList != null,
                          type: "text",
                          value: this.state.themeName,
                          placeholder: "Special Price!",
                          onChange: this.handleChangeState("themeName")
                        }}
                        helpText={this.state.themeName == "" ? <span className="txt-c-r">* จำเป็นต้องใส่</span> : ""}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                        ข้อความ SMS
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={10} lg={10}>
                      <CustomInput
                        error={this.state.txtSMSMessage == ""}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.txtSMSMessage,
                          placeholder: Lg.ts("ข้อความ SMS"),
                          multiline: true,
                          rows: "4",
                          rowsMax: "8",
                          onChange: this.handleChangeState("txtSMSMessage")
                        }}
                        helpText={(
                          <div key=" ">
                            <span>{this.state.txtSMSMessage == "" ? <span className="txt-c-r">* จำเป็นต้องใส่</span> : ""} </span>
                            <span className="txt-c-b"> {Lg.ts("(ตัวอย่าง) สวัสดีคุณ<{first_name}> <{last_name}> คุณคือผู้โชคดี <{code_number}>")} </span>
                          </div>
                        )}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        วันที่เริ่มแสดง
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} className={"m-b-2"}>
                      <FormControl fullWidth>
                        {
                          !this.state.startDatetimeStatusReload ?
                            <Datetime
                              timeFormat='HH:mm:ss'
                              defaultValue={this.state.startDatetime ? ISOToDateDMYAndFullTime(this.state.startDatetime) : undefined}
                              onChange={e => this.handleDateTimeChange("startDatetime", e)}
                              inputProps={{
                                readOnly: true,
                                placeholder: "กดเลือกวันที่ตรงนี้",
                              }}
                            />
                            : null
                        }
                      </FormControl>
                      <small className="txt-c-dorg2">{Lg.ts('เป็นการกำหนดให้ รูปแบบ SMS นี้ที่เตรียมไว้ให้แสดงในระหว่างวันไหนถึงวันไหน / ถ้าไม่ระบุจะแสดงตลอด')}</small>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1} className={"m-b-2"}>
                      {
                        this.state.startDatetime ?
                          <Button
                            className={this.props.classes.buttonTable}
                            size="sm"
                            round
                            onClick={() => this.handleDateTimeRemove("startDatetime")}
                            color="danger"
                            className="remove"
                          >
                            <TimerOffIcon />
                          </Button>
                          : null
                      }
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} lg={2}>
                      <FormLabel className={classes.labelHorizontal + " txt-c-b2 date-a22334"}>
                        วันที่ปิดแสดง
                      </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3} className={"m-b-2"}>
                      <FormControl fullWidth>
                        {
                          !this.state.endDatetimeStatusReload ?
                            <Datetime
                              timeFormat='HH:mm:ss'
                              defaultValue={this.state.endDatetime ? ISOToDateDMYAndFullTime(this.state.endDatetime) : undefined}
                              onChange={e => this.handleDateTimeChange("endDatetime", e)}
                              inputProps={{
                                // disabled: this.state.dataList != null,
                                readOnly: true,
                                placeholder: "กดเลือกวันที่ตรงนี้",
                              }}
                            />
                            : null
                        }
                      </FormControl >
                      <small className="txt-c-dorg2">{Lg.ts('สามารถกำหนดแค่ วันเริ่มแสดง หรือ วันที่ปิดแสดง ก็ได้')}</small>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1} className={"m-b-2"}>
                      {
                        this.state.endDatetime ?
                          <Button
                            className={this.props.classes.buttonTable}
                            size="sm"
                            round
                            onClick={() => this.handleDateTimeRemove("endDatetime")}
                            color="danger"
                            className="remove"
                          >
                            <TimerOffIcon />
                          </Button>
                          : null
                      }
                    </GridItem>
                    <GridItem xs={8}>
                    </GridItem>
                    <GridItem xs={4}>
                      <Button
                        // size="sm"
                        fullWidth
                        round
                        color="success"
                        className={this.props.classes.mb4}
                        onClick={e => this.handleSave()}
                      >
                        {
                          this.state._id ?
                            <span>
                              <EditIcon className={this.props.classes.icons} />
                              {Lg.ts('บันทึกแก้ไข')}
                            </span>
                            :
                            <span>
                              <AddCircleIcon className={this.props.classes.icons} />
                              {Lg.ts('สร้าง')}
                            </span>
                        }
                      </Button>{" "}
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
function mapStateToProps({ listsThemeSMS }) {
  return {
    listsThemeSMS: listsThemeSMS
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsThemeSMSUpdate }
  )
)(ProjectCreateAndEditManagement)
